<div>
    <p class="admin-ps"><b>{{'Add a program override ODL'|translate}}.</b></p>
    
    <div class="admin-ps">
        <div class="row admin-row-ip">
          <div class="col-lg-2 admin-width">
            <label class="admin-center">{{'Description'|translate}}</label><br>
            <input type="text">
          </div>
          <div class="col-lg-2 admin-width">
            <label class="admin-center">{{'VIN'|translate}}</label><br>
            <input type="text">
          </div>
          <div class="col-lg-2">
            <label class="admin-center"></label><br>
            <input class="admin-add-btn" type="submit" name="add" value="{{'add'|translate}}">
          </div>
       </div>
    </div>
    </div>
